import React from 'react'

import { getNextGISLayersHandbook } from 'services/apiRequests'

import { useDispatch } from 'react-redux'
import { setDirectoryItems, setId, setVersionId } from 'store/directorySlice'

const useGetNextGISLayers = (requestData: boolean | undefined) => {
  const dispatch = useDispatch()

  const tryToGetNextGISLayers = async () => {
    await getNextGISLayersHandbook().then((res) => {
      dispatch(setId(res.data.id))
      dispatch(setVersionId(res.data.id))
      dispatch(
        setDirectoryItems(
          res.data.units.map((unit) => {
            return {
              ...unit,
              modified: false,
            }
          }),
        ),
      )
    })
  }

  React.useEffect(() => {
    tryToGetNextGISLayers().then()
  }, [requestData])

  return
}

export default useGetNextGISLayers
